/**
 * Deutsche Texte. Hinweis zur Syntax (vue-i18n): {name} ist ein Platzhalter,
 * die Zeichen @ $ | { } müssen als {'@'} usw. geschrieben werden.
 */
export default {
  meta: {
    home: 'Temporäre E-Mail-Adresse',
    login: 'Anmelden',
    mail: 'Postfach',
    faq: 'FAQ',
    blacklist: 'Blacklist-Prüfung',
    removal: 'Austragungsantrag',
    imprint: 'Impressum',
  },
  nav: {
    create: 'Neues Postfach',
    login: 'Anmelden',
    mail: 'Postfach',
    faq: 'FAQ',
    blacklist: 'Blacklist',
    imprint: 'Impressum',
    language: 'Sprache',
    menu: 'Menü',
  },
  theme: {
    label: 'Darstellung',
    system: 'System',
    light: 'Hell',
    dark: 'Dunkel',
    toggle: 'Darstellung: {current} – umschalten auf {next}',
    hint: '„System“ folgt der Einstellung Ihres Betriebssystems bzw. Browsers.',
  },
  common: {
    loading: 'Lädt …',
    cancel: 'Abbrechen',
    save: 'Speichern',
    days: '{n} Tag | {n} Tage',
    address: 'E-Mail-Adresse',
    accountName: 'Accountname',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    lifetime: 'Laufzeit',
    validUntil: 'gültig bis {date}',
  },
  home: {
    title: 'Temporäre E-Mail-Adresse in wenigen Sekunden',
    intro:
      'Schützen Sie Ihre private Adresse: Mit einem Wegwerf-Postfach von anonmails.de melden Sie sich bei Diensten, Newslettern oder zum Testen an, ohne Ihr eigentliches Postfach mit Spam zu füllen.',
    features: [
      'Laufzeit 1 bis 50 Tage, jederzeit verlängerbar',
      'Abruf im Browser oder per POP3/POP3S',
      'Keine persönlichen Daten nötig',
    ],
    donateText: 'Gefällt Ihnen anonmails.de? Der Dienst ist kostenlos – mit einer Spende unterstützen Sie den Betrieb.',
    donate: 'Spenden mit PayPal',
    loggedIn: 'Sie sind als {email} angemeldet.',
    toMailbox: 'Zum Postfach',
  },
  create: {
    title: 'Neues Postfach anlegen',
    wish: 'Wunschadresse',
    checking: 'Prüfe …',
    available: '{email} ist frei.',
    taken: 'Diese Adresse ist bereits vergeben.',
    reserved: 'Diese Adresse ist reserviert.',
    invalid: 'Erlaubt sind {min}–{max} Zeichen: a–z, 0–9, Punkt, Bindestrich, Unterstrich.',
    lifetimeHint:
      'Danach werden die Nachrichten gelöscht. Die Adresse bleibt Ihnen erhalten und kann mit dem letzten Passwort reaktiviert werden.',
    submit: 'Postfach anlegen',
    busy: 'Wird angelegt …',
    terms: 'Mit dem Anlegen akzeptieren Sie die Nutzungsbedingungen im {link}.',
    termsLink: 'Impressum',
  },
  login: {
    title: 'Anmelden',
    tabLogin: 'Anmelden',
    tabReactivate: 'Reaktivieren',
    submit: 'Anmelden',
    busy: 'Anmelden …',
    noAccount: 'Noch kein Postfach?',
    expiredNotice: 'Ihr Postfach ist abgelaufen. Sie können es mit Ihrem letzten Passwort reaktivieren.',
    lastPassword: 'Letztes Passwort',
    reactivateHint: 'Das Postfach wird ab heute für die gewählte Laufzeit aktiviert. Frühere Nachrichten sind gelöscht.',
    reactivateSubmit: 'Reaktivieren',
    reactivateBusy: 'Wird reaktiviert …',
    addressHint: 'Accountname genügt, die Domain wird ergänzt.',
  },
  password: {
    min: 'Mindestens {min} Zeichen.',
    mismatch: 'Die Passwörter stimmen nicht überein.',
    title: 'Passwort ändern',
    current: 'Aktuelles Passwort',
    new: 'Neues Passwort',
    repeat: 'Neues Passwort wiederholen',
    hint: 'Das neue Passwort gilt sofort auch für POP3-Programme.',
    changed: 'Passwort geändert',
    change: 'Passwort ändern',
  },
  extend: {
    button: 'Verlängern',
    title: 'Postfach verlängern',
    current: 'Gültig bis {date}.',
    rule: 'Das neue Ablaufdatum darf höchstens {max} Tage in der Zukunft liegen.',
    rule0: 'Das Postfach hat bereits die maximale Laufzeit von {max} Tagen ab heute.',
    newDate: 'Neues Ablaufdatum: {date}',
    submit: 'Verlängern',
    busy: 'Wird verlängert …',
    done: 'Verlängert bis {date}',
  },
  mail: {
    logout: 'Abmelden',
    folders: {
      inbox: 'Posteingang',
      drafts: 'Entwürfe',
      sent: 'Gesendet',
      junk: 'Spam',
      trash: 'Papierkorb',
      archive: 'Archiv',
    },
    messages: '{n} Nachricht | {n} Nachrichten',
    empty: 'Keine Nachrichten',
    noSubject: '(kein Betreff)',
    unknown: '(unbekannt)',
    attachment: 'Anhang',
    flag: 'Markieren',
    unflag: 'Markierung entfernen',
    from: 'Von:',
    to: 'An:',
    cc: 'Cc:',
    download: 'Herunterladen (.eml)',
    downloadTitle: 'Nachricht im Original als .eml-Datei speichern',
    markUnread: 'Als ungelesen markieren',
    remoteBlocked: 'Externe Inhalte wurden zum Schutz Ihrer Privatsphäre blockiert.',
    loadRemote: 'Trotzdem laden',
    noneSelected: 'Keine Nachricht ausgewählt',
  },
  manage: {
    select: 'Auswählen',
    selectAll: 'Alle auf dieser Seite auswählen',
    selected: '{n} ausgewählt',
    saveSelected: 'Speichern (ZIP)',
    saveSelectedTitle: 'Ausgewählte Nachrichten als ZIP mit .eml-Dateien herunterladen',
    deleteSelected: 'Löschen',
    delete: 'Löschen',
    deleteOne: 'Nachricht löschen',
    confirmDelete: 'Nachricht endgültig löschen? | {n} Nachrichten endgültig löschen?',
    emptyFolder: '{folder} leeren',
    confirmEmpty: 'Alle Nachrichten in „{folder}“ endgültig löschen? Das kann nicht rückgängig gemacht werden.',
    deleted: '{n} Nachricht gelöscht | {n} Nachrichten gelöscht',
    usage: 'Postfach: {used} von {limit}',
    usageOnly: 'Postfach: {used}',
    settings: 'Einstellungen',
    settingsTitle: 'Einstellungen',
    accountInfo: 'Postfach',
    createdAt: 'Angelegt am',
    expiresAt: 'Gültig bis',
    remaining: 'Verbleibend',
    remainingDays: 'noch {n} Tag | noch {n} Tage',
    expired: 'abgelaufen',
    remoteImages: 'Externe Bilder in HTML-Mails immer laden',
    remoteImagesHint: 'Externe Bilder verraten dem Absender, dass und wann Sie die Mail geöffnet haben (Tracking). Standard: blockiert, einzeln mit „Trotzdem laden“ anzeigen.',
    saved: 'Einstellungen gespeichert',
    deleteAccount: 'Account löschen',
    deleteAccountTitle: 'Account löschen',
    deleteAccountText: 'Alle Nachrichten werden sofort endgültig gelöscht und Sie werden abgemeldet. Die Adresse {email} bleibt Ihnen erhalten und kann später mit dem letzten Passwort reaktiviert werden.',
    deleteAccountConfirm: 'Ja, alle Nachrichten löschen und den Account schließen',
    deleteAccountSubmit: 'Account löschen',
    deleteAccountBusy: 'Wird gelöscht …',
    accountDeleted: 'Ihr Account wurde gelöscht. Sie können die Adresse unter „Anmelden“ → „Reaktivieren“ wieder aktivieren.',
  },
  faq: {
    or: 'oder',
    title: 'Häufige Fragen',
    items: [
      {
        q: 'Was ist anonmails.de?',
        a: 'anonmails.de stellt kostenlose, temporäre E-Mail-Postfächer bereit. Damit schützen Sie Ihre private Adresse, etwa bei Registrierungen, Newslettern oder zum Testen, und halten Ihr eigentliches Postfach frei von Spam.',
      },
      {
        q: 'Wie lange ist ein Postfach gültig?',
        a: 'Beim Anlegen wählen Sie eine Laufzeit von {options} Tagen. Das Ablaufdatum sehen Sie nach der Anmeldung oben im Postfach.',
      },
      {
        q: 'Kann ich die Laufzeit verlängern?',
        a: 'Ja. Nach der Anmeldung können Sie das Postfach mit „Verlängern“ jederzeit verlängern, und zwar bis höchstens {max} Tage ab dem heutigen Tag. Die Restlaufzeit wird dabei angerechnet.',
      },
      {
        q: 'Was passiert, wenn ein Postfach abläuft?',
        a: 'Alle Nachrichten werden gelöscht. Die Adresse bleibt Ihnen aber erhalten: Unter „Anmelden“ → „Reaktivieren“ können Sie das Postfach mit dem zuletzt verwendeten Passwort wieder aktivieren.',
      },
      {
        q: 'Kann ich mit anonmails.de E-Mails versenden?',
        a: 'Nein. anonmails.de ist kein E-Mail-Provider: Nachrichten können nur empfangen, gelesen und gespeichert werden. Zum Versenden nutzen Sie bitte einen anderen (kostenlosen) Anbieter.',
      },
      {
        q: 'Gibt es eine Größenbeschränkung?',
        a: 'Ja. Eine einzelne E-Mail darf höchstens {maxMessage} MB groß sein, größere Nachrichten werden abgelehnt. Ein Postfach fasst insgesamt {quota} MB.',
      },
      {
        q: 'Kann ich das Postfach mit einem E-Mail-Programm abrufen?',
        a: 'Ja, per POP3 bzw. POP3S, zum Beispiel mit Thunderbird: Server {host}, Port 995 (SSL/TLS) oder 110 (STARTTLS), Benutzername ist die vollständige E-Mail-Adresse, dazu Ihr Postfach-Passwort.',
      },
      {
        q: 'Warum wurde mein Postfach gesperrt?',
        a: 'Postfächer, die gegen die Nutzungsbedingungen (siehe Impressum) verstoßen, werden gesperrt. Gesperrte Postfächer können nicht reaktiviert werden.',
      },
      {
        q: 'Was ist die Blacklist {zone}?',
        a: 'Eine DNS-Blacklist (DNSBL) mit IPv4-Adressen von Mailservern, die als Spam-Quelle aufgefallen sind. Auf der Seite „Blacklist“ prüfen Sie, ob eine Adresse gelistet ist.',
      },
    ],
  },
  blacklist: {
    title: 'Blacklist-Prüfung',
    intro:
      '{zone} ist eine DNS-Blacklist (DNSBL) mit IPv4-Adressen von Mailservern, die als Spam-Quelle aufgefallen sind. Prüfen Sie hier, ob eine Adresse gelistet ist.',
    label: 'IPv4-Adresse',
    submit: 'Prüfen',
    busy: 'Prüfe …',
    clean: '{ip} ist nicht gelistet.',
    listed: '{ip} ist gelistet.',
    unavailable: 'Die Blacklist ist derzeit nicht erreichbar. Bitte später erneut versuchen.',
    codes: 'Rückgabewert',
    reason: 'Begründung',
    usageTitle: 'Verwendung in SpamAssassin',
    usage: 'Zum Beispiel in /etc/spamassassin/local.cf eintragen:',
    removalForm: 'Austragung beantragen',
    removalIntro: 'Ist eine Adresse gelistet, können Sie nach der Prüfung oben direkt die Austragung beantragen.',
    removalHint: 'Beschreiben Sie kurz, warum die Adresse zu Unrecht gelistet ist oder was behoben wurde (z. B. offenes Relay geschlossen, kompromittiertes Konto gesperrt).',
    name: 'Name oder Firma',
    notice: 'Begründung',
    noticeMin: 'Mindestens {min} Zeichen.',
    captcha: 'Sicherheitscode',
    captchaHint: 'Bitte die Zeichen aus dem Bild eingeben (Groß-/Kleinschreibung egal).',
    captchaReload: 'Neues Bild',
    captchaAlt: 'Sicherheitscode als Bild',
    removalSubmit: 'Antrag senden',
    removalBusy: 'Wird gesendet …',
    removalCreated: 'Ihr Antrag für {ip} ist eingegangen und wird bearbeitet.',
    removalUpdated: 'Für {ip} liegt bereits ein Antrag vor. Ihre Nachricht wurde ergänzt.',
    removalTrack: 'Den Bearbeitungsstand sehen Sie jederzeit unter diesem Link (bitte speichern):',
    removalTrackLink: 'Bearbeitungsstand anzeigen',
    downloadTitle: 'DNSBL-Check für Windows',
    downloadText: 'Mit dem Programm DNSBL-Check prüfen Sie IP-Adressen unter Windows direkt gegen die Blacklist.',
    downloadLink: 'DNSBLCheck.zip herunterladen',
    removalTitle: 'Austragung',
    removal: 'Ihre Adresse ist zu Unrecht gelistet? Schreiben Sie uns mit der IP-Adresse und einer kurzen Begründung, die Kontaktdaten stehen im {link}.',
  },
  removal: {
    title: 'Austragungsantrag',
    requestedAt: 'Antrag vom',
    status: 'Status',
    state: {
      open: 'Eingegangen',
      review: 'In Bearbeitung',
      rejected: 'Abgelehnt',
      done: 'Erledigt',
    },
    text: {
      open: 'Ihr Antrag ist eingegangen und wird in Kürze zur Prüfung freigegeben.',
      review:
        'Ihr Antrag wird geprüft. Wird bis {date} kein weiterer Spam von dieser Adresse registriert, wird sie anschließend automatisch aus der Blacklist entfernt.',
      rejected:
        'Ihr Antrag wurde am {date} abgelehnt: Seit dem Antrag wurde erneut Spam von dieser Adresse registriert, oder für die Adresse gab es in letzter Zeit bereits einen Antrag. Die Adresse wird nach Ablauf der Speicherfrist automatisch entfernt, sofern kein weiterer Spam eingeht.',
      done: 'Die Adresse wurde am {date} aus der Blacklist entfernt. Zwischengespeicherte DNS-Antworten anderer Server können noch einige Zeit bestehen bleiben.',
    },
    requestCount: 'Für diese Adresse sind {n} Anträge eingegangen.',
    bookmark: 'Diese Seite können Sie als Lesezeichen speichern:',
    checkAgain: 'Adresse erneut prüfen',
    notFound: 'Der Antrag wurde nicht gefunden oder ist bereits abgeschlossen und archiviert.',
    backToCheck: 'Zur Blacklist-Prüfung',
  },
  imprint: {
    title: 'Impressum',
    provider: 'Angaben gemäß § 5 DDG',
    contact: 'Kontakt',
    disclaimerTitle: 'Haftungsausschluss',
    contentTitle: 'Haftung für Inhalte',
    content:
      'Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte sowie für daraus entstehende Schäden wird keine Haftung übernommen.',
    linksTitle: 'Haftung für Links',
    links:
      'Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte kein Einfluss besteht. Für diese fremden Inhalte ist stets der jeweilige Anbieter oder Betreiber verantwortlich.',
    termsTitle: 'Nutzungsbedingungen',
    terms: [
      'Mit dem Anlegen einer Adresse akzeptieren Sie diese Nutzungsbedingungen.',
      'Bei der Nutzung des Dienstes sind alle geltenden nationalen und internationalen Gesetze einzuhalten.',
      'Der Dienst ist kostenlos. Es besteht kein Anspruch auf Verfügbarkeit oder Nutzbarkeit; der Dienst kann jederzeit ohne Vorankündigung eingestellt werden.',
      'Bei schwerwiegenden Verstößen werden Postfächer gesperrt oder gelöscht.',
      'Empfangene Nachrichten sollten Sie selbst sichern. Schadensersatzansprüche sind ausgeschlossen.',
      'Die Nutzungsbedingungen können sich ändern.',
    ],
    logsTitle: 'Protokolldaten',
    logs: 'Beim Aufruf der Website werden Datum und Uhrzeit, Browser, Referrer und IP-Adresse in den Protokolldateien des Servers gespeichert.',
  },
  errors: {
    generic: 'Die Aktion ist derzeit nicht möglich.',
    unavailable: 'Der Dienst ist derzeit nicht erreichbar.',
    rate_limited: 'Zu viele Versuche. Bitte warten Sie und versuchen Sie es später erneut.',
    removal_not_found: 'Der Antrag wurde nicht gefunden oder ist bereits archiviert.',
    invalid_credentials: 'E-Mail-Adresse oder Passwort falsch.',
    account_locked: 'Das Postfach ist gesperrt.',
    account_expired: 'Das Postfach ist abgelaufen.',
    address_taken: 'Diese Adresse ist bereits vergeben.',
    local_part_length: 'Die Adresse muss {min} bis {max} Zeichen lang sein.',
    local_part_chars: 'Erlaubt sind Kleinbuchstaben, Ziffern sowie Punkt, Bindestrich und Unterstrich (nicht am Anfang oder Ende, keine doppelten Punkte).',
    local_part_reserved: 'Diese Adresse ist reserviert.',
    weak_password: {
      too_short: 'Das Passwort muss mindestens {min} Zeichen lang sein.',
      too_long: 'Das Passwort darf höchstens {max} Zeichen lang sein.',
      invalid_chars: 'Das Passwort enthält ungültige Zeichen.',
      whitespace: 'Das Passwort darf nicht mit einem Leerzeichen beginnen oder enden.',
      contains_address: 'Das Passwort darf die E-Mail-Adresse nicht enthalten.',
    },
    wrong_password: 'Das aktuelle Passwort ist falsch.',
    same_password: 'Das neue Passwort muss sich vom bisherigen unterscheiden.',
    not_expired: 'Das Postfach ist noch aktiv und muss nicht reaktiviert werden.',
    invalid_days: 'Bitte eine der angebotenen Laufzeiten wählen.',
    extend_limit: 'Das Postfach kann derzeit um höchstens {max} Tage verlängert werden.',
    extend_max: 'Das Postfach hat bereits die maximale Laufzeit.',
    not_listed: '{ip} ist nicht gelistet und muss nicht ausgetragen werden.',
    dnsbl_unavailable: 'Die Blacklist ist derzeit nicht erreichbar. Bitte später erneut versuchen.',
    captcha_invalid: 'Der Sicherheitscode ist falsch oder abgelaufen. Bitte den neuen Code eingeben.',
    invalid_ip: 'Bitte eine gültige IPv4-Adresse eingeben.',
    session_expired: 'Bitte melden Sie sich erneut an.',
  },
};
